import React, { Component } from 'react';
import CountUp from 'react-countup';
import NumberSearchForm from '../../about/number-search/number-search';
import TypeSearchForm from '../../about/type-search/type-search';
import InternalService from '../../../services/internal-api';
import './reference-band.css';

class ReferenceBand extends Component {
  stampsData = new InternalService();

  state = {
    specimensCount: 0,
  };

  componentDidMount() {
    this.stampsData.getSpecimensCount()
      .then((body) => {
        this.setState({
          specimensCount: body.data["count(1)"],
        });
      })
      .catch((err) => console.error('Ошибка загрузки specimensCount', err));
  }

  handleDownload = () => {
    window.open(`${this.stampsData._apiBase}yanin-html/`, '_blank');
  };

  render() {
    const { specimensCount } = this.state;

    return (
      <div className="reference-band">
        {/* Первая пара */}
        <div className="reference-item">
          <div className="ref-title">Find by specimen number</div>
          <NumberSearchForm />
        </div>

        <div className="reference-item">
          <div className="ref-title">Seals in the database</div>
          <CountUp
            className="ref-numbers"
            start={specimensCount * 0.995}
            end={specimensCount}
            duration={20}
            useEasing={true}
            useGrouping={true}
            separator=" "
            decimals={0}
          />
        </div>

        {/* Вторая пара */}
        <div className="reference-item">
          <div className="ref-title">Find by type</div>
          <TypeSearchForm />
        </div>

        <div className="reference-item">
          <div className="ref-title">Yanin/Gaydukov to SAR T</div>
          <button className="ref-download" onClick={this.handleDownload}>
            Download printable mapping
          </button>
        </div>
      </div>
    );
  }
}

export default ReferenceBand;
